import { InputAdornment, makeStyles } from '@material-ui/core'
import React from 'react'

import { Form, FormikTimePicker, FormikTextField } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  topCols: {
    [theme.breakpoints.up('tablet')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  topCol: {
    marginBottom: `${theme.spacing(2)}px !important`,
    [theme.breakpoints.up('tablet')]: {
      marginBottom: 0,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      '&:first-child': {
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
      },
      width: `calc(50% - ${theme.spacing(1)}px)`,
    },
  },
}))

const BusinessDetails = () => {
  const classes = useStyles()
  return (
    <Form>
      <div className={classes.topCols}>
        <div className={classes.topCol}>
          <Form.InputGroup title="Business Info">
            <FormikTextField
              name="name"
              margin="normal"
              label="Business Name"
              fullWidth
            />
            <FormikTextField
              name="phoneNumber"
              label="Phone Number"
              margin="normal"
              fullWidth
            />
          </Form.InputGroup>
          <Form.InputGroup title="Primary Contact">
            <FormikTextField
              name="primaryContactName"
              margin="normal"
              label="Name"
              fullWidth
            />
            <FormikTextField
              name="primaryContactEmail"
              label="Email"
              margin="normal"
              type="email"
              fullWidth
            />
          </Form.InputGroup>
          <Form.InputGroup title="Registered Address">
            <FormikTextField
              name="registeredAddress.name"
              margin="normal"
              label="Name"
              fullWidth
            />
            <FormikTextField
              name="registeredAddress.line1"
              margin="normal"
              label="Address Line 1"
              fullWidth
            />
            <FormikTextField
              name="registeredAddress.line2"
              margin="normal"
              label="Address Line 2 (optional)"
              fullWidth
            />
            <FormikTextField
              name="registeredAddress.city"
              margin="normal"
              label="City"
              fullWidth
            />
            <FormikTextField
              name="registeredAddress.county"
              margin="normal"
              label="County"
              fullWidth
            />
            <FormikTextField
              name="registeredAddress.postcode"
              margin="normal"
              label="Postcode"
              fullWidth
            />
          </Form.InputGroup>
        </div>
        <div className={classes.topCol}>
          <Form.InputGroup title="Ordering And Delivery">
            <FormikTextField
              name="deliveryArea"
              margin="normal"
              label="Delivery area"
              fullWidth
            />
            <FormikTextField
              name="orderNotificationEmail"
              label="Order notification email address"
              margin="normal"
              fullWidth
            />
          </Form.InputGroup>
          <Form.InputGroup title="Default Agreement Terms">
            <FormikTextField
              name="defaultMinimumOrder"
              margin="normal"
              label="Minimum Order"
              fullWidth
              placeholder="0.00"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">£</InputAdornment>
                ),
              }}
            />
            <FormikTimePicker
              InputLabelProps={{ shrink: true }}
              name="defaultOrderCutoff"
              margin="normal"
              label="Order cutoff time"
              placeholder="HH:MM"
              fullWidth
            />
            <FormikTextField
              name="defaultDeliveryTime"
              margin="normal"
              label="Delivery Time"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">within</InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">day(s)</InputAdornment>
                ),
              }}
            />
            <FormikTextField
              name="defaultPaymentTerms"
              margin="normal"
              label="Payment Terms"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">within</InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">day(s)</InputAdornment>
                ),
              }}
            />
          </Form.InputGroup>
        </div>
      </div>
    </Form>
  )
}

export default BusinessDetails
